import styled from 'styled-components';
import { Tooltip, Popover, Space } from 'antd';
import { getSize, getColor, TextLinkButton } from '@lib/common';
import Image from 'next/image';
import { PlusCircleOutlined } from '@ant-design/icons'; // Styles

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ActionButtonsArea = styled.div.withConfig({
  displayName: "card-actionscomponent__ActionButtonsArea",
  componentId: "sc-1uhouy7-0"
})(["display:flex;align-items:center;gap:", ";"], getSize('padding4'));
export var StyledActionButtonWrapper = styled.div.withConfig({
  displayName: "card-actionscomponent__StyledActionButtonWrapper",
  componentId: "sc-1uhouy7-1"
})(["display:inline-flex;border-radius:", ";"], getSize('radiusS'));
export var StyledActionButton = styled(TextLinkButton).withConfig({
  displayName: "card-actionscomponent__StyledActionButton",
  componentId: "sc-1uhouy7-2"
})(["margin:", ";padding:", ";display:flex;align-items:center;justify-content:center;border-radius:", ";transition:background-color 0.2s ease,color 0.2s ease;color:", " !important;svg{color:", " !important;transition:color 0.2s ease;}&:hover{background-color:", ";color:", " !important;svg{color:", " !important;}opacity:0.8;}&:disabled{opacity:0.5;cursor:not-allowed;background-color:transparent !important;color:", " !important;svg{color:", " !important;}*{pointer-events:none;}}"], getSize('padding0'), getSize('padding8'), getSize('radiusSm'), function (_ref) {
  var $color = _ref.$color;
  return $color || getColor('textIntWhite');
}, function (_ref2) {
  var $color = _ref2.$color;
  return $color || getColor('textIntWhite');
}, function (_ref3) {
  var $hoverBgColor = _ref3.$hoverBgColor;
  return $hoverBgColor || getColor('fillBgSub');
}, function (_ref4) {
  var $hoverColor = _ref4.$hoverColor;
  return $hoverColor || getColor('fillIntActive');
}, function (_ref5) {
  var $hoverColor = _ref5.$hoverColor;
  return $hoverColor || getColor('fillIntActive');
}, function (_ref6) {
  var $color = _ref6.$color;
  return $color || getColor('textIntWhite');
}, function (_ref7) {
  var $color = _ref7.$color;
  return $color || getColor('textIntWhite');
});
export var StyledEditButton = styled(TextLinkButton).withConfig({
  displayName: "card-actionscomponent__StyledEditButton",
  componentId: "sc-1uhouy7-3"
})(["padding:0;border:none;background:transparent;"]);
export var StyledMoreButton = styled(TextLinkButton).withConfig({
  displayName: "card-actionscomponent__StyledMoreButton",
  componentId: "sc-1uhouy7-4"
})(["margin:", ";padding:", ";display:flex;align-items:center;justify-content:center;border-radius:", ";transition:background-color 0.2s ease,color 0.2s ease;color:", " !important;svg{color:", " !important;transition:color 0.2s ease;}&:hover{background-color:", ";color:", " !important;svg{color:", " !important;}}"], getSize('padding0'), getSize('padding8'), getSize('radiusSm'), getColor('textIntWhite'), getColor('textIntWhite'), getColor('fillBgSub'), getColor('fillIntActive'), getColor('fillIntActive'));
export var TooltipWrapper = styled.div.withConfig({
  displayName: "card-actionscomponent__TooltipWrapper",
  componentId: "sc-1uhouy7-5"
})([".ant-tooltip-inner{font-size:", " !important;padding:", " ", " !important;min-height:auto !important;}"], getSize('typo12'), getSize('padding4'), getSize('padding8'));
export var StyledActionIcon = styled(Image).withConfig({
  displayName: "card-actionscomponent__StyledActionIcon",
  componentId: "sc-1uhouy7-6"
})(["transition:opacity 0.2s ease;&:hover{color:", ";fill:", ";}"], getColor('fillIntActive'), getColor('fillIntActive')); // Component

export var CardActions = function CardActions(_ref8) {
  var _ref8$isOnlyRemaining = _ref8.isOnlyRemainingSection,
      isOnlyRemainingSection = _ref8$isOnlyRemaining === void 0 ? false : _ref8$isOnlyRemaining,
      onEdit = _ref8.onEdit,
      onDelete = _ref8.onDelete,
      onMention = _ref8.onMention,
      moreContent = _ref8.moreContent,
      openPopoverId = _ref8.openPopoverId,
      onPopoverChange = _ref8.onPopoverChange,
      sectionId = _ref8.sectionId,
      addSectionAboveLabel = _ref8.addSectionAboveLabel,
      addSectionBelowLabel = _ref8.addSectionBelowLabel,
      onCreateSectionAbove = _ref8.onCreateSectionAbove,
      onCreateSectionBelow = _ref8.onCreateSectionBelow,
      actions = _ref8.actions,
      _ref8$disabledActions = _ref8.disabledActions,
      disabledActions = _ref8$disabledActions === void 0 ? false : _ref8$disabledActions,
      isAiMode = _ref8.isAiMode;
  // Default to all actions if not specified
  var enabledActions = actions === undefined ? ['edit', 'mention', 'delete', 'more'] : actions;
  var showEdit = enabledActions.includes('edit');
  var showDelete = enabledActions.includes('delete');
  var showMore = enabledActions.includes('more');
  var showMention = enabledActions.includes('mention');

  var defaultMoreContent = /*#__PURE__*/_jsxs(Space, {
    direction: "vertical",
    children: [/*#__PURE__*/_jsx(TextLinkButton, {
      onClick: function onClick(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        onCreateSectionAbove === null || onCreateSectionAbove === void 0 ? void 0 : onCreateSectionAbove();
      },
      icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
      children: addSectionAboveLabel || 'Add Section Above'
    }), /*#__PURE__*/_jsx(TextLinkButton, {
      onClick: function onClick(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        onCreateSectionBelow === null || onCreateSectionBelow === void 0 ? void 0 : onCreateSectionBelow();
      },
      icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
      children: addSectionBelowLabel || 'Add Section Below'
    })]
  });

  return /*#__PURE__*/_jsx(TooltipWrapper, {
    children: /*#__PURE__*/_jsxs(ActionButtonsArea, {
      children: [showEdit && /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: "Edit",
          placement: "bottom",
          children: /*#__PURE__*/_jsx(StyledActionButton, {
            type: "text",
            disabled: disabledActions,
            onClick: function onClick(e) {
              if (disabledActions) return;
              e.stopPropagation();
              onEdit === null || onEdit === void 0 ? void 0 : onEdit(e);
            },
            children: /*#__PURE__*/_jsx(StyledActionIcon, {
              src: "/icons/edit.svg",
              width: 14,
              height: 14,
              alt: "edit"
            })
          })
        })
      }), showMention && isAiMode && /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: "Mention",
          placement: "bottom",
          children: /*#__PURE__*/_jsx(StyledActionButton, {
            type: "text",
            disabled: disabledActions,
            onClick: function onClick(e) {
              if (disabledActions) return;
              e.stopPropagation();
              onMention === null || onMention === void 0 ? void 0 : onMention(e);
            },
            children: /*#__PURE__*/_jsx(StyledActionIcon, {
              src: "/icons/ai.png",
              width: 16,
              height: 16,
              alt: "mention"
            })
          })
        })
      }), showDelete && /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: "Delete",
          placement: "bottom",
          mouseEnterDelay: 0.3,
          children: /*#__PURE__*/_jsx(StyledActionButton, {
            disabled: disabledActions,
            onClick: function onClick(e) {
              if (disabledActions) return;
              e.stopPropagation();
              onDelete === null || onDelete === void 0 ? void 0 : onDelete(e);
            },
            children: /*#__PURE__*/_jsx(StyledActionIcon, {
              src: "/icons/delete.svg",
              width: 16,
              height: 16,
              alt: "delete"
            })
          })
        })
      }), showMore && /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        children: /*#__PURE__*/_jsx(Popover, {
          placement: "right",
          content: moreContent || defaultMoreContent,
          open: disabledActions ? false : sectionId === openPopoverId,
          onOpenChange: function onOpenChange() {
            if (disabledActions) return;
            var isPopOverVisible = sectionId === openPopoverId;
            onPopoverChange === null || onPopoverChange === void 0 ? void 0 : onPopoverChange(isPopOverVisible ? '' : sectionId);
          },
          trigger: disabledActions ? [] : 'click',
          children: /*#__PURE__*/_jsx(Tooltip, {
            title: "More",
            placement: "bottom",
            mouseEnterDelay: 0.3,
            children: /*#__PURE__*/_jsx(StyledActionButton, {
              type: "text",
              disabled: disabledActions,
              onClick: function onClick(e) {
                if (disabledActions) return;
                e.stopPropagation();
                onPopoverChange === null || onPopoverChange === void 0 ? void 0 : onPopoverChange(sectionId);
              },
              children: /*#__PURE__*/_jsx(Image, {
                src: "/icons/more.svg",
                width: 16,
                height: 16,
                alt: "more"
              })
            })
          })
        })
      })]
    })
  });
};